import { ArrowUpRight, BookOpen, Images } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="ba-seccion" aria-label={seccion.titulo}>
      <div className="ba-seccion-interior">
        <EncabezadoSeccion p="ba" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ba-titulo-enlaces" />
        <Reveal>
          <div className="ba-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="ba-boton"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`ba-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "ba-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "ba-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="ba-seccion" aria-label={seccion.titulo}>
      <div className="ba-seccion-interior">
        <EncabezadoSeccion p="ba" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ba-titulo-accesos" />
        <Reveal>
          <div className="ba-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="ba-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={1.5} />
                <span>
                  <span className="ba-acceso-titulo">{item.datos.titulo}</span>
                  <span className="ba-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { pareja, evento, legal } = datos;
  const monograma = `${pareja.nombre1?.[0] || ""} · ${pareja.nombre2?.[0] || ""}`;

  return (
    <>
      <Marquee
        p="ba"
        textos={[`${pareja.nombre1} & ${pareja.nombre2}`, evento.fechaCorta, evento.ciudad]}
      />
      <section className="ba-seccion ba-cierre" data-testid="ba-cierre">
        <div className="ba-seccion-interior">
          <Reveal>
            <p className="ba-cierre-monograma" aria-hidden="true">
              {monograma}
            </p>
            <p className="ba-cierre-mensaje">{pareja.mensajeCierre}</p>
            <p className="ba-cierre-nombres">
              {pareja.nombre1} & {pareja.nombre2}
            </p>
            <div className="ba-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="ba-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="ba-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
